import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Link, useNavigate, Outlet } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Card from "react-bootstrap/Card";
import NavDropdown from "react-bootstrap/NavDropdown";
import { NavLink } from "react-router-dom";
import { logDOM } from "@testing-library/react";
export function Menutop(param) {
    var selectbranchID = param.selectbranchID, setSelectBranchID = param.setSelectBranchID;
    return /*#__PURE__*/ _jsx("div", {
        className: "scroll-menu mb-4",
        children: /*#__PURE__*/ _jsx(Card, {
            className: "card card-menu  ",
            children: /*#__PURE__*/ _jsxs(Card.Body, {
                className: "d-flex flex-wrap  ",
                style: {
                    paddingBottom: "0.3vw",
                    paddingTop: "0.9vw"
                },
                children: [
                    /*#__PURE__*/ _jsxs(Dropdown, {
                        className: "dropdown-st-1 ",
                        children: [
                            /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                id: "dropdown-basic",
                                className: "icon-m1",
                                children: "งานของฉัน"
                            }),
                            /*#__PURE__*/ _jsx(Dropdown.Menu, {
                                children: /*#__PURE__*/ _jsx(Dropdown.Item, {
                                    href: "#",
                                    children: "Action"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Dropdown, {
                        className: "dropdown-st-1",
                        children: [
                            /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                id: "dropdown-basic",
                                className: "icon-m2",
                                children: "จัดซื้อ"
                            }),
                            /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                children: [
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/distributor",
                                        className: "slide-item",
                                        children: "ผู้จัดจำหน่าย"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/purchase/requisition",
                                        className: "slide-item",
                                        children: "ใบขอซื้อ PR"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/purchase/orders",
                                        className: "slide-item",
                                        children: "ใบสั่งซื้อ PO"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/purchase/order/create",
                                        className: "slide-item",
                                        children: "ใบกำกับการซื้อ"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Dropdown, {
                        className: "dropdown-st-1",
                        children: [
                            /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                id: "dropdown-basic",
                                className: "icon-m3",
                                children: "คลังสินค้า"
                            }),
                            /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                children: [
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "#",
                                        className: "slide-item",
                                        children: "งานของฉัน"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/goods-receipt",
                                        className: "slide-item",
                                        children: "ใบรับสินค้า GR"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "#",
                                        className: "slide-item",
                                        children: "งานคลัง"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "#",
                                        className: "slide-item",
                                        children: "จัดการคลังสินค้า"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "#",
                                        className: "slide-item",
                                        children: "ตั้งค่าคลังสินค้า"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Dropdown, {
                        className: "dropdown-st-1",
                        children: [
                            /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                id: "dropdown-basic",
                                className: "icon-m4",
                                children: "ขาย"
                            }),
                            /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                children: [
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "#",
                                        className: "slide-item",
                                        children: "ตารางราคาสินค้า"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "#",
                                        className: "slide-item",
                                        children: "ลูกค้า"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/sale/quotation",
                                        className: "slide-item",
                                        children: "ใบเสนอราคา QO"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/sale/sale-order",
                                        className: "slide-item",
                                        children: "ใบสั่งขาย SO"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "#",
                                        className: "slide-item",
                                        children: "ใบรับมัดจำ"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/sale/invoice",
                                        className: "slide-item",
                                        children: "ใบแจ้งหนี้"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/sale/delivery-order",
                                        className: "slide-item",
                                        children: "ใบจัดส่งสินค้า DO"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "#",
                                        className: "slide-item",
                                        children: "ใบวางบิล"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/sale/receipt",
                                        className: "slide-item",
                                        children: "ใบเสร็จ"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "#",
                                        className: "slide-item",
                                        children: "ใบลดหนี้"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(NavDropdown, {
                        title: "การเงินและบัญชี",
                        id: "nav-dropdown",
                        bsPrefix: "icon-m5",
                        className: "dropdown-st-1",
                        style: {
                            fontSize: " 0.8vw"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                href: "/financial-accounting/creditor",
                                eventKey: "4.1",
                                children: "GR Review"
                            }),
                            /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                href: "/financial-accounting/expenses",
                                eventKey: "4.1",
                                children: "ใบบันทึกค่าใช้จ่าย"
                            }),
                            /*#__PURE__*/ _jsxs(NavDropdown, {
                                title: "เชื่อมต่อ PEAK",
                                id: "nav-dropdown",
                                drop: "end",
                                children: [
                                    /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                        href: "/financial-accounting/peak-connection/pes",
                                        eventKey: "1.1",
                                        children: "บันทึกซื้อสินค้า"
                                    }),
                                    /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                        eventKey: "1.2",
                                        children: "บันทึกค้าใช้จ่าย"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Dropdown, {
                        className: "dropdown-st-1",
                        children: [
                            /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                id: "dropdown-basic",
                                className: "icon-m6",
                                children: "การผลิต"
                            }),
                            /*#__PURE__*/ _jsx(Dropdown.Menu, {
                                children: /*#__PURE__*/ _jsx(Dropdown.Item, {
                                    href: "#",
                                    children: "Action"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Dropdown, {
                        className: "dropdown-st-1",
                        children: [
                            /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                id: "dropdown-basic",
                                className: "icon-m7",
                                children: "บุคคล"
                            }),
                            /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                children: [
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/emps",
                                        className: "slide-item ",
                                        children: "รายชื่อพนักงาน"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/emp/permission",
                                        className: "slide-item",
                                        children: "กำหนดสิทธิ์ผู้ใช้งาน"
                                    }),
                                    /*#__PURE__*/ _jsx(Dropdown.Item, {
                                        href: "/permission",
                                        className: "slide-item",
                                        children: "สร้างสิทธิ์ผู้ใช้งาน"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(NavDropdown, {
                        title: "รายงาน",
                        id: "nav-dropdown",
                        bsPrefix: "icon-m8",
                        className: "dropdown-st-1",
                        style: {
                            fontSize: " 0.8vw"
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(NavDropdown, {
                                title: "รายงานการซื้อ",
                                id: "nav-dropdown",
                                drop: "end",
                                children: [
                                    /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                        href: "/report/buy/order",
                                        eventKey: "1.1",
                                        children: "รายงานมูลค่าการซื้อรายวันตามใบสั่งซื้อ"
                                    }),
                                    /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                        href: "/report/buy/po-item",
                                        eventKey: "1.2",
                                        children: "รายงานมูลค่าการซื้อแยกรายสินค้า"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(NavDropdown, {
                                title: "รายงานการขาย",
                                id: "nav-dropdown",
                                drop: "end",
                                children: /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                    href: "/report/sale/product-do",
                                    eventKey: "1.1",
                                    children: "รายงานยอดขายรายสินค้า จาก DO"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(NavDropdown, {
                                title: "รายงานคลังสินค้า",
                                id: "nav-dropdown",
                                drop: "end",
                                children: [
                                    /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                        href: "/report/buy/supplier",
                                        eventKey: "1.1",
                                        children: "รายงานมูลค่าสินค้าตามผู้จัดจำหน่ายจากใบรับสินค้า"
                                    }),
                                    /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                        href: "/report/buy/gr-item",
                                        eventKey: "1.2",
                                        children: "รายงานการรับสินค้าเข้าคลังตามรายการ"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                eventKey: "4.1",
                                children: "รายงานเจ้าหนี้"
                            }),
                            /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                eventKey: "4.1",
                                children: "รายงานลูกหนี้"
                            }),
                            /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                eventKey: "4.1",
                                children: "รายงานภาษี"
                            }),
                            /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                eventKey: "4.1",
                                children: "รายงานการเงิน"
                            }),
                            /*#__PURE__*/ _jsx(NavDropdown, {
                                title: "รายงานบัญชี",
                                id: "nav-dropdown",
                                drop: "end",
                                children: /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                    href: "/report/financial/gr-item-expense",
                                    eventKey: "1.1",
                                    children: "รายงานต้นทุนสินค้าจากการรับสินค้าเข้าคลัง"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Dropdown, {
                        className: "dropdown-st-1",
                        children: [
                            /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                id: "dropdown-basic",
                                className: "icon-m9",
                                children: "การวิเคราะห์"
                            }),
                            /*#__PURE__*/ _jsx(Dropdown.Menu, {
                                children: /*#__PURE__*/ _jsx(Dropdown.Item, {
                                    href: "#",
                                    children: "Action"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Dropdown, {
                        className: "dropdown-st-1",
                        children: [
                            /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                id: "dropdown-basic",
                                className: "icon-m10",
                                children: "งานระบบทั่วไป"
                            }),
                            /*#__PURE__*/ _jsx(Dropdown.Menu, {
                                children: /*#__PURE__*/ _jsx(Dropdown.Item, {
                                    href: "#",
                                    children: "Action"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
